import ListPagination from 'components/list_pagination'
import LoadingIndicator from 'components/loading_indicator'
import Pagination from 'entities/pagination'
import RecruiterCandidateDestination from 'entities/user_notice/recruiter_destination_candidate'
import { includes, intersection, isEmpty, union, uniq, xor } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import ButtonForAllSelect from './button_for_all_select'
import styles from './list.module.scss'
import RecruiterListItem from './recruiter_list_item'
import SearchField from './search_field'

const RecruiterList = ({
  isLoading,
  pagination,
  recruiters,
  recruiterIds,
  cancelButton,
  completeButton,
  onChangePage,
  onChangeKeyword,
  onUpdateSelection
}) => {
  const handleItemChecked = id => {
    const newSelections = xor(recruiterIds, [id])
    onUpdateSelection(newSelections)
  }
  const listRecruiterIds = recruiters.map(r => r.id)
  const isAllSelected =
    intersection(listRecruiterIds, recruiterIds).length === listRecruiterIds.length && recruiterIds.length > 0
  const handleAllChecked = () => {
    onUpdateSelection(isAllSelected ? xor(recruiterIds, listRecruiterIds) : uniq(union(recruiterIds, listRecruiterIds)))
  }
  const recruiterList = isEmpty(recruiters) ? null : (
    <div className={styles.scrollableContent}>
      {recruiters.map(recruiter => (
        <RecruiterListItem
          key={recruiter.id}
          isChecked={isAllSelected || includes(recruiterIds, recruiter.id)}
          recruiter={recruiter}
          onChange={handleItemChecked}
        />
      ))}
    </div>
  )

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerRow}>
          <ButtonForAllSelect
            disabled={isLoading}
            isAllSelected={isAllSelected}
            target={I18n.t('components.destinations_field.recruiter_list.target')}
            pagination={pagination}
            onChecked={handleAllChecked}
          />
          <SearchField className={styles.searchField} onChange={onChangeKeyword} />
        </div>
        <div className={styles.headerRow}>
          <div className={styles.description}>{I18n.t('components.destinations_field.recruiter_list.description')}</div>
        </div>
      </div>
      <div className={styles.body}>
        {isLoading ? <LoadingIndicator /> : recruiterList}
        <ListPagination className={styles.pagination} pagination={pagination} onPageClick={onChangePage} />
        <div className={styles.footer}>
          {cancelButton}
          {completeButton}
        </div>
      </div>
    </div>
  )
}

RecruiterList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  recruiters: PropTypes.arrayOf(PropTypes.instanceOf(RecruiterCandidateDestination)).isRequired,
  pagination: PropTypes.instanceOf(Pagination).isRequired,
  recruiterIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  cancelButton: PropTypes.element.isRequired,
  completeButton: PropTypes.element.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeKeyword: PropTypes.func.isRequired,
  onUpdateSelection: PropTypes.func.isRequired
}

export default RecruiterList
